(() => {
  'use strict';
  const T = window.ttT || {};
  const woorden = (s) => (s || '').toLowerCase().split(',').map((x) => x.trim()).filter(Boolean);
  const losvast = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const keuze = (s) => woorden(s).map(losvast).join('|') || 'xxgeenxx';
  const $ = (sel, root = document) => root.querySelector(sel);
  const money = (cents) => new Intl.NumberFormat('nl-NL', {
    style: 'currency', currency: window.ttShop?.currency || 'EUR'
  }).format(cents / 100);
  class TtDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      document.addEventListener('click', this.onDocClick = (e) => {
        const opener = e.target.closest(`[data-drawer="${this.id}"]`);
        if (opener) { e.preventDefault(); this.open(); }
      });
      this.dialog.addEventListener('click', (e) => {
        if (e.target.closest('[data-close]') || e.target === this.dialog) this.close();
      });
    }
    disconnectedCallback() { document.removeEventListener('click', this.onDocClick); }
    open() { this.dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
    close() {
      this.dialog.close();
      if (!document.querySelector('dialog.drawer[open]')) document.documentElement.style.overflow = '';
    }
  }
  customElements.define('tt-drawer', TtDrawer);
  const cart = {
    async get() { return (await fetch('/cart.js')).json(); },
    async add(id, qty = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: qty }] })
      });
      if (!res.ok) throw new Error((await res.json()).description || T.fout);
      return res.json();
    },
    async change(key, qty) {
      return (await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })).json();
    }
  };
  function renderProgress(total) {
    document.querySelectorAll('[data-progress]').forEach((el) => {
      const ship = Number(el.dataset.ship || 0);
      const fill = $('.progress__fill', el);
      const goal = $('.progress__goal', el);
      if (fill) fill.style.width = Math.min(100, (total / ship) * 100) + '%';
      if (!goal) return;
      if (total < ship) {
        goal.innerHTML = T.doel1.replace('{verzending}', money(ship - total));
      } else {
        goal.textContent = T.doel0;
      }
    });
  }
  async function refresh() {
    const data = await cart.get();
    document.querySelectorAll('[data-cart-count]').forEach(n => {
      n.textContent = data.item_count;
      n.hidden = data.item_count === 0;
    });
    renderProgress(data.total_price);
    const body = $('[data-cart-body]');
    if (body) {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
        const oud = $(sel), nieuw = html.querySelector(sel);
        if (oud && nieuw) oud.innerHTML = nieuw.innerHTML;
      });
      renderProgress(data.total_price);
    }
    return data;
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const id = form.querySelector('[name=id]')?.value;
    if (!id) return;
    const label = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig…'; }
    try {
      await cart.add(Number(id), Number(form.querySelector('[name=quantity]')?.value || 1));
      await refresh();
      document.getElementById('cart-drawer')?.open();
    } catch (err) {
      const slot = form.querySelector('[data-error]');
      if (slot) slot.textContent = err.message;
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const next = Math.max(0, Number(input.value) + Number(step.dataset.qty));
      input.value = next;
      await cart.change(step.closest('[data-key]').dataset.key, next);
      if (input.name.startsWith('updates')) { window.location.reload(); return; }
      await refresh();
      return;
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      await cart.change(remove.closest('[data-key]').dataset.key, 0);
      await refresh();
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('input[name^="updates"]');
    if (!input) return;
    const line = input.closest('[data-key]');
    if (!line) return;
    await cart.change(line.dataset.key, Math.max(0, Number(input.value) || 0));
    window.location.reload();
  });
  document.querySelectorAll('[data-hide-with-js]').forEach(b => b.setAttribute('hidden', ''));
  // Mailadres terugzetten (zie snippets/mail-link.liquid): omgekeerd en in base64.
  const zetMail = (root = document) => root.querySelectorAll('a[data-m]').forEach((a) => {
    try {
      const adres = atob(a.dataset.m).split('').reverse().join('');
      a.href = 'mailto:' + adres;
      const t = a.querySelector('[data-m-tekst]');
      if (t) t.textContent = adres;
      a.removeAttribute('data-m');
    } catch (e) {  }
  });
  zetMail();
  document.addEventListener('shopify:section:load', (e) => zetMail(e.target));
  // Easy Tickets telt op de eventslijst de plekken van alle tickettypes bij elkaar op.
  // Delen de types een gezamenlijk aantal plekken (Midnight Release: 4 types, 5 plekken),
  // dan staat er 4 x 5 = 20. Het echte getal staat als availableTotal in de eventgegevens
  // van de app; dat zetten we erin zodra de app de kaarten heeft getekend.
  const etLijst = document.querySelector('.shopify-app-block[id$="__events"]');
  if (etLijst) {
    const etGedaan = new WeakSet();
    const etPlekken = () => etLijst.querySelectorAll('a.et-card[href*="/products/"]').forEach(async (kaart) => {
      const plek = kaart.querySelector('.et-card__spots');
      if (!plek || etGedaan.has(plek) || !/\d/.test(plek.textContent)) return;
      etGedaan.add(plek);
      try {
        const handle = new URL(kaart.href).pathname.split('/products/')[1].split('/')[0];
        const p = await (await fetch(`/products/${handle}.js`)).json();
        const c = await (await fetch(`/apps/easy-tickets/api/event-config/${p.id}`)).json();
        const n = c && c.availableTotal;
        if (typeof n !== 'number') return;
        if (n > 0) plek.textContent = plek.textContent.replace(/\d+/, String(n));
        else plek.hidden = true;
      } catch (e) {  }
    });
    etPlekken();
    new MutationObserver(etPlekken).observe(etLijst, { childList: true, subtree: true });
  }
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-submit-on-change]');
    if (sel) sel.form?.submit();
  });
  const headerWrap = document.querySelector('.section-header')
    || document.querySelector('.header')?.parentElement;
  if (headerWrap) {
    const drempel = 100;
    const marge = 8;
    let vorige = window.scrollY;
    let omhoog = 0;
    let verborgen = false;
    const zet = (waarde) => {
      if (waarde === verborgen) return;
      verborgen = waarde;
      headerWrap.classList.toggle('is-hidden', waarde);
    };
    window.addEventListener('scroll', () => {
      const y = window.scrollY > 0 ? window.scrollY : 0;
      const d = y - vorige;
      vorige = y;
      if (y <= drempel) { omhoog = 0; zet(false); return; }
      if (d > 0) {
        omhoog = 0;
        if (!document.querySelector('dialog.drawer[open]')) zet(true);
      } else if (d < 0) {
        omhoog -= d;
        if (omhoog >= marge) zet(false);
      }
    }, { passive: true });
  }
  const navGroups = () => document.querySelectorAll('[data-nav-group][open]');
  document.addEventListener('click', (e) => {
    const inside = e.target.closest('[data-nav-group]');
    navGroups().forEach(g => { if (g !== inside) g.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') navGroups().forEach(g => g.removeAttribute('open'));
  });
  const raster = document.querySelector('[data-cards]');
  const meer = document.querySelector('[data-meer]');
  if (raster && meer && 'IntersectionObserver' in window) {
    let bezig = false;
    const kijker = new IntersectionObserver(async (regels) => {
      if (!regels[0].isIntersecting || bezig || !meer.dataset.meer) return;
      bezig = true;
      try {
        const res = await fetch(meer.dataset.meer);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('[data-cards] > *').forEach((el) => raster.appendChild(el));
        const volgende = doc.querySelector('[data-meer]');
        meer.dataset.meer = volgende ? volgende.dataset.meer : '';
      } catch (e) {
        meer.dataset.meer = '';
      }
      bezig = false;
      if (!meer.dataset.meer) { kijker.disconnect(); meer.remove(); }
    }, { rootMargin: '700px' });
    kijker.observe(meer);
  }
  const filterPanel = document.getElementById('filters');
  if (filterPanel) {
    filterPanel.querySelector('[data-apply]')?.setAttribute('hidden', '');
    filterPanel.addEventListener('change', (e) => {
      if (e.target.matches('[data-autosubmit]')) e.target.form?.submit();
    });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-filters-toggle]');
    if (!t || !filterPanel) return;
    const open = filterPanel.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('change', (e) => {
    const vink = e.target.closest('[data-cadeau]');
    const tekst = e.target.closest('[data-cadeau-tekst]');
    if (!vink && !tekst) return;
    if (vink) {
      document.querySelectorAll('[data-cadeau]').forEach((v) => { v.checked = vink.checked; });
      document.querySelectorAll('[data-cadeau-knop]').forEach((b) => { b.hidden = !vink.checked; });
    }
    if (tekst) {
      document.querySelectorAll('[data-cadeau-tekst]').forEach((v) => { v.value = tekst.value; });
      document.querySelectorAll('[data-cadeau-knop]').forEach((b) => {
        b.textContent = tekst.value.trim() ? T.berichtWijzig : T.berichtErbij;
      });
    }
    const aan = document.querySelector('[data-cadeau]')?.checked === true;
    const bericht = aan ? document.querySelector('[data-cadeau-tekst]')?.value.trim() || '' : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Cadeau: aan ? 'Ja' : '', Cadeaubericht: bericht } }),
    });
  });
  function bouwPdpTekst() {
    const sleutel = (t) => {
      t = (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (woorden(T.kopSmaak).some((w) => t.indexOf(w) === 0)) return 'smaak';
      if (woorden(T.kopIng).some((w) => t.indexOf(w) === 0)) return 'ing';
      if (woorden(T.kopZet).some((w) => t.indexOf(w) === 0)) return 'zet';
      return null;
    };
    const pdp = document.querySelector('[data-pdp-tabs]');
    if (pdp) {
      const src = pdp.querySelector('[data-src]');
      const ben = src?.querySelector('.tat-benefits-container');
      const benMount = document.querySelector('[data-benefits]');
      if (ben && benMount) {
        ben.style.margin = '0';
        benMount.appendChild(ben);
      }
      const bakken = { magic: [], smaak: [], ing: [], zet: [] };
      let huidig = 'magic';
      Array.from(src?.childNodes || []).forEach((node) => {
        if (node.nodeType === 3) { if (node.textContent.trim()) bakken[huidig].push(node); return; }
        if (node.nodeType !== 1) return;
        const k = sleutel(node.textContent);
        if (k) {
          huidig = k;
          if (node.textContent.replace(/\s+/g, ' ').trim().length <= 14) return;
          const b = node.querySelector('b,strong');
          if (b && sleutel(b.textContent)) b.remove();
          bakken[huidig].push(node);
          return;
        }
        bakken[huidig].push(node);
      });
      if (src && (bakken.smaak.length || bakken.ing.length || bakken.zet.length || ben)) {
        ['magic', 'smaak', 'ing'].forEach((k) => {
          const p = pdp.querySelector(`[data-panel="${k}"]`);
          if (p) bakken[k].forEach((n) => p.appendChild(n));
        });
        src.hidden = true;
        const nav = pdp.querySelector('[data-tabnav]');
        if (nav) nav.hidden = false;
        const eerste = pdp.querySelector('[data-panel="magic"]');
        if (eerste) eerste.classList.add('is-active');
        ['smaak', 'ing'].forEach((k) => {
          const p = pdp.querySelector(`[data-panel="${k}"]`);
          if (p && !p.textContent.trim()) pdp.querySelector(`[data-tab="${k}"]`)?.setAttribute('hidden', '');
        });
        pdp.querySelectorAll('[data-tab]').forEach((btn) => {
          btn.addEventListener('click', () => {
            pdp.querySelectorAll('[data-tab]').forEach((b) => {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });
            pdp.querySelectorAll('[data-panel]').forEach((p) => p.classList.remove('is-active'));
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
            pdp.querySelector(`[data-panel="${btn.dataset.tab}"]`)?.classList.add('is-active');
          });
        });
      }
    }
  }
  function bouwGalerij() {
    const track = document.querySelector('[data-gal-track]');
    if (track && !track.dataset.klaar) {
      track.dataset.klaar = '1';
      const slides = [...track.querySelectorAll('.gal__slide')];
      const thumbs = [...document.querySelectorAll('.pdp__media .thumbs a')];
      const prev = document.querySelector('.gal__nav--prev');
      const next = document.querySelector('.gal__nav--next');
      let huidig = 0;
      const ganaar = (i) => {
        huidig = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[huidig].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      const zetPijlen = () => {
        if (prev) prev.disabled = huidig === 0;
        if (next) next.disabled = huidig === slides.length - 1;
      };
      document.querySelectorAll('[data-gal]').forEach((btn) => {
        btn.addEventListener('click', () => ganaar(huidig + Number(btn.dataset.gal)));
      });
      thumbs.forEach((a, i) => a.addEventListener('click', (e) => { e.preventDefault(); ganaar(i); }));
      const strook = document.querySelector('.pdp__media .thumbs');
      const rij = strook && strook.closest('[data-thumbrow]');
      const meet = () => rij.classList.toggle('is-scroll', strook.scrollWidth > strook.clientWidth + 2);
      const inBeeld = () => {
        const a = thumbs[huidig];
        if (!rij || !a) return;
        const links = a.offsetLeft - 8;
        const rechts = links + a.offsetWidth + 16 - strook.clientWidth;
        strook.scrollLeft = Math.min(links, Math.max(rechts, strook.scrollLeft));
      };
      if (rij) {
        rij.querySelectorAll('[data-thumb]').forEach((btn) => btn.addEventListener('click', () => {
          strook.scrollLeft += btn.dataset.thumb * strook.clientWidth * 0.8;
        }));
        window.addEventListener('resize', meet, { passive: true });
        meet();
      }
      if ('IntersectionObserver' in window) {
        const kijker = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            huidig = slides.indexOf(en.target);
            thumbs.forEach((a, i) => a.classList.toggle('is-active', i === huidig));
            zetPijlen();
            inBeeld();
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach((el) => kijker.observe(el));
      }
      zetPijlen();
    }
  }
  function bouwKoopbalk() {
    const mainBuy = document.querySelector('form[data-add][data-main]');
    const buybar = document.querySelector('[data-buybar]');
    if (mainBuy && buybar && !buybar.dataset.klaar && 'IntersectionObserver' in window) {
      buybar.dataset.klaar = '1';
      new IntersectionObserver(([entry]) => {
        const voorbij = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', voorbij);
      }).observe(mainBuy);
    }
  }
  const bouwProductpagina = () => { bouwPdpTekst(); bouwGalerij(); bouwKoopbalk(); };
  bouwProductpagina();
  document.addEventListener('shopify:section:load', bouwProductpagina);
  const faqZoek = $('[data-faqzoek]');
  if (faqZoek) faqZoek.addEventListener('input', () => {
    const q = faqZoek.value.trim().toLowerCase();
    let raak = 0;
    document.querySelectorAll('[data-faqitem]').forEach((el) => {
      const hit = !q || el.textContent.toLowerCase().includes(q);
      el.hidden = !hit;
      if (hit) { raak++; if (q) el.open = true; }
    });
    document.querySelectorAll('[data-faqgroep]').forEach((g) => {
      g.hidden = !g.querySelector('[data-faqitem]:not([hidden])');
    });
    const leeg = $('[data-faqleeg]');
    if (leeg) leeg.hidden = raak > 0;
  });
  const bouwSlider = (hs) => {
    if (hs.dataset.klaar) return;
    hs.dataset.klaar = '1';
    const slides = [...hs.querySelectorAll('[data-hs-slide]')];
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let nu = 0, tikker = null, lus = null, leeft = false;
    hs.querySelectorAll('[data-vonken]').forEach((laag) => {
      for (let i = 0; i < Number(laag.dataset.vonken || 0); i++) {
        const v = document.createElement('span');
        v.classList.add('hs__vonk');
        v.style.left = `${(Math.random() * 100).toFixed(1)}%`;
        v.style.setProperty('--v', `${(3 + Math.random() * 6).toFixed(1)}px`);
        v.style.setProperty('--vd', `${(5 + Math.random() * 6).toFixed(1)}s`);
        v.style.setProperty('--vw', `${(Math.random() * 7).toFixed(1)}s`);
        laag.appendChild(v);
      }
    });
    // De plaats van de zwevende beelden en het product staat in de CSS (--x/--xm),
    // per schermbreedte. Vroeger zette dit script ze na het laden, en dan
    // versprongen ze op desktop (layout shift).
    // De beelden van slide twee en verder staan in data-src, zodat ze de eerste
    // tekening niet ophouden. Wek ze zodra de browser tijd over heeft, en in elk
    // geval voordat hun slide in beeld komt.
    const wek = (slide) => {
      if (!slide || slide.dataset.gewekt) return;
      slide.dataset.gewekt = '1';
      slide.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };
    const rustmoment = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
    addEventListener('load', () => rustmoment(() => slides.forEach(wek)), { once: true });
    const teller = hs.querySelector('[data-hs-nu]');
    const toon = (n) => {
      nu = (n + slides.length) % slides.length;
      wek(slides[nu]);
      wek(slides[(nu + 1) % slides.length]);
      slides.forEach((s, i) => s.classList.toggle('is-on', i === nu));
      if (teller) teller.textContent = nu + 1;
    };
    hs.querySelectorAll('[data-hs-ga]').forEach((btn) => {
      btn.addEventListener('click', () => { toon(nu + Number(btn.dataset.hsGa)); herstart(); });
    });
    let vanX = 0, vanY = 0;
    hs.addEventListener('touchstart', (e) => { vanX = e.touches[0].clientX; vanY = e.touches[0].clientY; }, { passive: true });
    hs.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - vanX;
      const dy = e.changedTouches[0].clientY - vanY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { toon(nu + (dx < 0 ? 1 : -1)); herstart(); }
    }, { passive: true });
    const wacht = Number(hs.dataset.auto || 0) * 1000;
    const start = () => { if (wacht && slides.length > 1 && leeft) tikker = setInterval(() => toon(nu + 1), wacht); };
    const stop = () => { clearInterval(tikker); tikker = null; };
    const herstart = () => { stop(); start(); };
    const dingen = [];
    let mx = 0, my = 0, dx = 0, dy = 0;
    if (hs.dataset.zweef && !rustig) {
      hs.querySelectorAll('[data-diep]').forEach((el) => dingen.push({
        el,
        midden: el.classList.contains('hs__zweef') || el.classList.contains('hs__pak'),
        diep: Number(el.dataset.diep) || 1.5,
        t: Math.random() * 6.28,
        snel: 0.5 + Math.random() * 0.5,
        wijd: 5 + Math.random() * 7
      }));
      hs.addEventListener('mousemove', (e) => {
        const r = hs.getBoundingClientRect();
        dx = (e.clientX - r.left) / r.width - 0.5;
        dy = (e.clientY - r.top) / r.height - 0.5;
      });
      hs.addEventListener('mouseleave', () => { dx = 0; dy = 0; });
    }
    const beeld = () => {
      mx += (dx - mx) * 0.06; my += (dy - my) * 0.06;
      dingen.forEach((o) => {
        o.t += 0.02 * o.snel;
        const zy = Math.sin(o.t) * o.wijd;
        const zx = Math.cos(o.t * 0.7) * o.wijd * 0.5;
        const basis = o.midden ? 'translate(-50%,-50%) ' : '';
        o.el.style.transform = `${basis}translate(${(-mx * o.diep * 22 + zx).toFixed(1)}px,${(-my * o.diep * 22 + zy).toFixed(1)}px)`;
      });
      lus = requestAnimationFrame(beeld);
    };
    const zet = (aan) => {
      if (aan === leeft) return;
      leeft = aan;
      hs.classList.toggle('is-stil', !aan);
      if (aan) { if (dingen.length && lus === null) lus = requestAnimationFrame(beeld); start(); }
      else { if (lus !== null) { cancelAnimationFrame(lus); lus = null; } stop(); }
    };
    new IntersectionObserver(([e]) => zet(e.isIntersecting && !document.hidden), { threshold: 0.01 }).observe(hs);
    document.addEventListener('visibilitychange', () => { if (document.hidden) zet(false); });
  };
  const bouwSliders = () => document.querySelectorAll('[data-hs]').forEach(bouwSlider);
  bouwSliders();
  document.addEventListener('shopify:section:load', bouwSliders);
  const bouwBanner = (bb) => {
    if (bb.dataset.klaar) return;
    bb.dataset.klaar = '1';
    const spoor = bb.querySelector('[data-bb-spoor]');
    if (!spoor || !spoor.children.length) return;
    const echt = Array.from(spoor.children);
    const kopie = () => echt.map((plak) => {
      const k = plak.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return k;
    });
    kopie().forEach((k) => spoor.insertBefore(k, echt[0]));
    kopie().forEach((k) => spoor.appendChild(k));
    // De breedte van één rijtje, gemeten aan het verschil tussen de eerste plak
    // van de kopie ervoor en de eerste plak van het echte rijtje. Meten via
    // scrollWidth zou de ruimte links en rechts van het spoor meetellen.
    const rij = () => spoor.children[echt.length].offsetLeft - spoor.children[0].offsetLeft;
    // Waar het spoor moet staan om deze plak in het midden te zetten.
    const plek = (plak) => plak.offsetLeft + plak.offsetWidth / 2 - spoor.clientWidth / 2;
    // Alle plakken zijn even breed, dus welke er nu in het midden staat volgt uit
    // de stand van het spoor. Scheelt het aflopen van de hele rij.
    const dichtstbij = () => Math.round((spoor.scrollLeft - plek(spoor.children[0])) / (rij() / echt.length));
    // Rechtstreeks zetten, met het happen even uit, anders trekt scroll-snap de
    // band meteen naar het dichtstbijzijnde boek terug.
    const zet = (x) => {
      spoor.style.scrollSnapType = 'none';
      spoor.scrollLeft = x;
      spoor.style.scrollSnapType = '';
    };
    // Welke plak in het midden hoort te staan. We tellen die zelf bij, en kijken
    // niet naar waar de band op dit moment is: klikt iemand twee keer snel achter
    // elkaar, dan telt de tweede klik er gewoon bij op in plaats van dat hij in
    // de nog lopende beweging verdwijnt.
    let doel = echt.length;
    let schuivend = false;
    const terugzetten = () => {
      if (schuivend) return;
      doel = dichtstbij();
      const r = rij();
      const basis = plek(spoor.children[echt.length]);
      const x = spoor.scrollLeft;
      if (x < basis - r * 0.5) { zet(x + r); doel += echt.length; }
      else if (x > basis + r * 0.5) { zet(x - r); doel -= echt.length; }
    };
    zet(plek(spoor.children[doel]));
    let tekening = null;
    const schuif = (doel) => {
      cancelAnimationFrame(tekening);
      const begin = spoor.scrollLeft;
      const afstand = doel - begin;
      if (!afstand) return;
      schuivend = true;
      spoor.style.scrollSnapType = 'none';
      const t0 = performance.now();
      const stapje = (nu) => {
        const deel = Math.min((nu - t0) / 420, 1);
        spoor.scrollLeft = begin + afstand * (1 - Math.pow(1 - deel, 3));
        if (deel < 1) {
          tekening = requestAnimationFrame(stapje);
        } else {
          spoor.style.scrollSnapType = '';
          schuivend = false;
          terugzetten();
        }
      };
      tekening = requestAnimationFrame(stapje);
    };
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ga = (richting) => {
      const plak = spoor.children[doel + richting];
      if (!plak) return;
      doel += richting;
      if (rustig) { zet(plek(plak)); terugzetten(); return; }
      schuif(plek(plak));
    };
    let stil = null;
    spoor.addEventListener('scroll', () => {
      clearTimeout(stil);
      stil = setTimeout(terugzetten, 150);
    }, { passive: true });
    const wacht = Number(bb.dataset.bb || 0) * 1000;
    let tikker = null, inbeeld = false, hand = false;
    const start = () => { if (wacht && !rustig && inbeeld && !hand && !tikker) tikker = setInterval(() => ga(1), wacht); };
    const stop = () => { clearInterval(tikker); tikker = null; };
    const pauze = (aan) => { hand = aan; if (aan) stop(); else start(); };
    bb.querySelectorAll('[data-bb-ga]').forEach((knop) => {
      knop.addEventListener('click', () => { ga(Number(knop.dataset.bbGa)); stop(); start(); });
    });
    bb.addEventListener('pointerenter', () => pauze(true));
    bb.addEventListener('pointerleave', () => pauze(false));
    bb.addEventListener('focusin', () => pauze(true));
    bb.addEventListener('focusout', () => pauze(false));
    spoor.addEventListener('touchstart', () => pauze(true), { passive: true });
    new IntersectionObserver(([e]) => {
      inbeeld = e.isIntersecting && !document.hidden;
      inbeeld ? start() : stop();
    }, { threshold: 0.2 }).observe(bb);
  };
  const bouwBanners = () => document.querySelectorAll('[data-bb]').forEach(bouwBanner);
  bouwBanners();
  document.addEventListener('shopify:section:load', bouwBanners);
})();
